import { getDistance } from './getDistance'

export const getDistanceBetweenUserAndSpot = (spotCoords) => {
  const userGPSPosition = JSON.parse(localStorage.getItem('exactUserLocation'))
  if (!userGPSPosition) return ''

  const { latitude, longitude } = userGPSPosition
  const distanceInMetres = (getDistance(latitude, longitude, spotCoords.latitude, spotCoords.longitude) * 1000).toFixed()

  if (distanceInMetres > 50000) return ''

  if (distanceInMetres < 1000) {
    return distanceInMetres + ' м'
  } else {
    return (+distanceInMetres / 1000).toFixed(1) + ' км'
  }
}
